import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  MuiDialog,
  Typography,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { useNavigate } from "react-router-dom";
import { ReportProblemSuccessModalStyles } from "./ReportProblemSuccessModal.styles";

interface IProps {
  open: boolean;
  handleClose: () => void;
}

export const ReportProblemSuccessModal = ({ open, handleClose }: IProps) => {
  const navigate = useNavigate();
  const sx = ReportProblemSuccessModalStyles();

  return (
    <MuiDialog
      title={getLocalizedText("tenant.report_problem.modal.title")}
      open={open}
      maxWidth="500px"
      width="500px"
      toggleOpen={handleClose}
      actions={[
        {
          label: getLocalizedText("tenant.report_modal.btn"),
          onClick: () => navigate("/tasks"),
        },
      ]}
    >
      <Typography variant="body2" sx={sx.content.description}>
        {getLocalizedText("tenant.report_modal.details")}
      </Typography>
    </MuiDialog>
  );
};
